<template>
    <div class="home">
        <div style="margin-bottom: 200px; text-align: center;">
            <ion-label class="title" color="dark" @click="androidInterface">메인페이지</ion-label>
        </div>
        <div @click="$router.push('/login')" style="text-align: center;">
            <a href="#">로그인페이지로 이동</a>
        </div>
        <div @click="playLecture(14002)" style="text-align: center;">
            <a href="#">1강 입자가 운동한다고?</a>
        </div>
        <div @click="playLecture(13417)" style="text-align: center;">
            <a href="#">1강 식물을 잎의 생김새에 따라 분류하기</a>
        </div>

        <footer-toolbar />
    </div>
</template>

<script>
    import * as biz from '../utils/biz';
    import FooterToolbar from "../components/footer/FooterToolbar";

    export default {
        name: 'home',
        components: {FooterToolbar},
        created() {
            this.$store.state.basicPlayerVisiblity = true;
        },
        mounted() {
            window.callJsFunction = this.callJsFunction;
        },
        methods: {
            androidInterface() {
                document.querySelector('ion-label.title').style.color = "black";
                Android.showToast("녹색으로 변신");
            },
            callJsFunction(message) {
                document.querySelector('ion-label.title').style.color = message;
            },
            playLecture(courseNo) {
                biz.playAudioPlayer(courseNo);
            }
        }
    }
</script>

<style scoped lang="scss">
    div.home {
        width: 300px;
        margin: 100px auto;
    }
</style>
